import { useEffect, useState } from 'react';
import { carouselIndex, setCarouselIndex } from '../rewards/carousel-state';

/**
 * The visible item of a rotating carousel: moves on every `intervalMs`,
 * wrapping after the last, unless paused. The position is shared across
 * mounts, so a new step's carousel picks up where the last one was.
 */
export function useCarouselRotation(count: number, intervalMs: number, paused: boolean): number {
  const [active, setActive] = useState(() => carouselIndex() % Math.max(count, 1));
  useEffect(() => {
    if (paused || count <= 1) return;
    const timer = setInterval(() => {
      const next = (carouselIndex() + 1) % count;
      setCarouselIndex(next);
      setActive(next);
    }, intervalMs);
    return () => clearInterval(timer);
  }, [count, intervalMs, paused]);
  // The prize list can shrink while mounted (a new link in the same tab), so
  // the shared position is kept inside it.
  return active % Math.max(count, 1);
}
